module.exports = __webpack_public_path__ + "img/nodejs.d42672d4.png";